import { FunnelType } from '../../shared/constants';
import { ErrorEntry } from '../types';

export interface SignUpPayload {
    email: string;
    password: string;
    username: string;
    firstName?: string;
    lastName?: string;
    funnel: FunnelType;
    inBeetlesMigrateSignupWebRollout: boolean;
}

type SignUpUsernameErrorValue =
    | 'username'
    | 'user_not_allowed'
    | 'user_taken'
    | 'user_too_short'
    | 'user_too_long'
    | 'sign_up_rate_limit';

type SignUpEmailErrorValue = 'email_exists' | 'email_format';

export const SIGNUP_EMAIL_ERRORS = ['email_exists', 'email_format', 'email_illegal_domain'] as const;
export const SIGNUP_USERNAME_ERRORS = [
    'username_format',
    'username_illegal',
    'username_exists',
    'username_too_short',
    'username_too_long',
    'location_not_allowed',
] as const;
export const SIGNUP_PASSWORD_ERRORS = ['password_format'] as const;
export const SIGNUP_COMMON_ERRORS = ['unspecified'] as const;

export type SignupEmailError = (typeof SIGNUP_EMAIL_ERRORS)[number];
export type SignupUsernameError = (typeof SIGNUP_USERNAME_ERRORS)[number];
export type SignupPasswordError = (typeof SIGNUP_PASSWORD_ERRORS)[number];
export type SignupCommonError = (typeof SIGNUP_COMMON_ERRORS)[number];

export type SignUpError = SignupEmailError | SignupUsernameError | SignupPasswordError | SignupCommonError;

export interface SignUpResponse {
    status: 'success' | 'failure';
    redirect_url?: string;
    external_id?: string;
    guest_checkout?: Record<string, unknown>;
    errorKeys?: (ErrorEntry<'username', SignUpUsernameErrorValue> | ErrorEntry<'email', SignUpEmailErrorValue>)[];

    error_keys?: SignUpError[];
}
